module.exports = __webpack_public_path__ + "img/cursos-gratis-2025.9491dc2e.png";